import React from "react";
import PropTypes from "prop-types";

function LiveNow({
    prefix,
    showStreamName,
    localizer,
    channelId,
    channelsByChannelId,
    isDisplayed,
}) {
    return (
        isDisplayed && (
            <div className={`${prefix}__live-now`}>
                <span>{localizer("LIVE_NOW")}</span>
                {showStreamName && (
                    <span className={`${prefix}__channel-name`}>
                        {localizer(channelsByChannelId[channelId].displayName)}
                    </span>
                )}
            </div>
        )
    );
}

LiveNow.propTypes = {
    prefix: PropTypes.string.isRequired,
    showStreamName: PropTypes.bool.isRequired,
    localizer: PropTypes.func.isRequired,
    channelId: PropTypes.string.isRequired,
    channelsByChannelId: PropTypes.object.isRequired,
    isDisplayed: PropTypes.bool.isRequired,
};

export default LiveNow;
